import * as React from 'react';
import { DropdownMenuContainer, IDropdownMenuContainerProps } from '../../containers/DropdownMenuContainer';
import { IOtherLinksSchema } from '../../repositories/header/entities/other_links/OtherLinksSchema';
import { TopMenuLinkContainer } from '../../containers/TopMenuLinkContainer';

export interface IMenuItemProps {
  trackingLabel?: string;
  name: string;
  isOpen: boolean;
  title: string;
  link?: string | null;
  dropdownMenusData: IDropdownMenuContainerProps;
  otherLinks?: IOtherLinksSchema | null;
  catalogDevelopersUrl?: string;
  onMouseOver(key: string): void;
  onMouseOut(key: string): void;
  handleCloseClick(key: string): void;
  isActive?: boolean;
}

export class MenuItem extends React.Component<IMenuItemProps> {
  private clickLink = () => {
    const { trackingLabel } = this.props;
    if (window._headerTrackingEvent && trackingLabel) {
      window._headerTrackingEvent(trackingLabel);
    }
  };

  private handleClose = () => {
    const { handleCloseClick, name } = this.props;

    handleCloseClick(name);
  };

  public render() {
    const { dropdownMenusData, name, isOpen, isActive, otherLinks, catalogDevelopersUrl, link, title } = this.props;

    return (
      <li
        key={name}
        className="c-header-bottom-menu-item"
        onMouseOver={() => this.props.onMouseOver(name)}
        onMouseOut={() => this.props.onMouseOut(name)}
      >
        <TopMenuLinkContainer
          link={link}
          name={name}
          onClickLink={this.clickLink}
          title={title}
          isOpen={isOpen}
          isActive={isActive}
        />
        <DropdownMenuContainer
          isOpen={isOpen}
          otherLinks={otherLinks}
          catalogDevelopersUrl={catalogDevelopersUrl}
          name={dropdownMenusData.name}
          links={dropdownMenusData.links}
          onClose={this.handleClose}
        />
      </li>
    );
  }
}
